<template>
    <div v-if="order">
    
        <div class="d-flex align-items-center mb-2">
    
            <b-button variant="outline-secondary" class="btn-icon rounded-circle mr-1" @click="$router.back()">
    
                <feather-icon icon="ChevronLeftIcon" size="20" />
    
            </b-button>
    
            <h4 class="mb-0">Ticimax Sipariş Detayı</h4>
    
        </div>
    
    
    
        <b-card class="mb-2">
    
            <div class="row text-center text-md-left justify-content-between align-items-center">
    
                <div class="col-md-3 mb-1 mb-md-0">
    
                    <p class="card-text text-muted mb-50">Sipariş No</p>
    
                    <h5 class="mb-0">{{ order.SiparisNo }}</h5>
    
                </div>
    
                <div class="col-md-3 mb-1 mb-md-0">
    
                    <p class="card-text text-muted mb-50">Sipariş Tarihi</p>
    
                    <h5 class="mb-0">{{ order.SiparisTarihi | formatDate }}</h5>
    
                </div>
    
                <div class="col-md-3 mb-1 mb-md-0">
    
                    <p class="card-text text-muted mb-50">Sipariş Durumu</p>
    
                    <h5 v-if="order.SiparisDurumu === 'Onaylandı'" class="mb-0 text-success">{{ order.SiparisDurumu }}</h5>
    
                    <h5 v-else class="mb-0 text-danger">{{ order.SiparisDurumu }}</h5>
    
                </div>
    
                <div class="col-md-3">
    
                    <p class="card-text text-muted mb-50">Sipariş Kaynağı</p>
    
                    <h5 class="mb-0">{{ order.SiparisKaynagi }}</h5>
    
                </div>
    
            </div>
    
        </b-card>
    
    
    
        <div class="row align-items-stretch">
    
            <div class="col-lg-8 d-flex flex-column">
    
                <b-card class="mb-2" v-if="order.KargoFirmaTanim">
    
                    <div class="d-flex justify-content-between">
    
                        <div>
    
                            <h5 class="card-title mb-1">Kargo Bilgileri</h5>
    
                            <p class="card-text mb-0">{{ order.KargoFirmaTanim }}</p>
    
                            <p v-if="order.KargoTakipNo" class="card-text text-muted">Takip No: {{ order.KargoTakipNo }}</p>
    
                        </div>
    
                        <div class="text-success d-flex align-items-center">
    
                            <feather-icon icon="TruckIcon" size="24" class="mr-1" />
    
                            <h5 class="mb-0">{{ order.Urunler[0] ? order.Urunler[0].DurumAd : "" }}</h5>
    
                        </div>
    
                    </div>
    
                </b-card>
    
    
    
                <b-card no-body class="flex-fill mb-0">
    
                    <h5 class="card-header">Sipariş Edilen Ürünler ({{ order.Urunler.length }} Kalem)</h5>
    
                    <div class="table-responsive">
    
                        <table class="table">
    
                            <thead>
    
                                <tr>
    
                                    <th width="10%">Ürün</th>
    
                                    <th>Ürün Bilgisi</th>
    
                                    <th class="text-right">Miktar</th>
    
                                    <th class="text-right">Birim Fiyat</th>
    
                                    <th class="text-right">KDV</th>
    
                                    <th class="text-right">Toplam</th>
    
                                </tr>
    
                            </thead>
    
                            <tbody>
    
                                <tr v-for="item in order.Urunler" :key="item.ID">
    
                                    <td><img :src="getProductImage(item.ResimYolu)" height="50" class="rounded border" style="border: 2px solid black;" alt="Ürün Resmi" /></td>
    
                                    <td>
    
                                        <div>{{ item.UrunAdi }}</div>
    
                                        <small class="text-muted">Stok Kodu: {{ item.StokKodu }}</small>
    
                                    </td>
    
                                    <td class="text-right">{{ item.Adet }}</td>
    
                                    <td class="text-right">{{ item.SatisAniSatisFiyat | formatPrice }}</td>
    
                                    <td class="text-right">-</td>

                                    <td class="text-right font-weight-bold">{{ item.Tutar * item.Adet | formatPrice }}</td>

                                </tr>
    
                            </tbody>
    
                        </table>
    
                    </div>
    
                </b-card>
    
            </div>
    
    
    
            <div class="col-lg-4 d-flex flex-column">
    
                <b-card title="Teslimat & Fatura Bilgileri" class="mb-2">
    
                    <h6>Teslimat Adresi</h6>
    
                    <p class="card-text text-muted">
    
                        <strong>{{ order.TeslimatAdresi.AliciAdi }}</strong><br /> {{ order.TeslimatAdresi.Adres }}<br /> {{ order.TeslimatAdresi.Ilce }} / {{ order.TeslimatAdresi.Il }}, {{ order.TeslimatAdresi.PostaKodu }}<br /> Tel: {{ order.TeslimatAdresi.AliciTelefon
    
                        }}
    
                    </p>
    
                    <hr />
    
                    <h6>Fatura Adresi</h6>
    
                    <p class="card-text text-muted">
    
                        <strong>{{ order.FaturaAdresi.FirmaAdi || order.FaturaAdresi.AliciAdi }}</strong><br /> {{ order.FaturaAdresi.Adres }}<br /> Vergi Dairesi: {{ order.FaturaAdresi.VergiDairesi }}<br /> Vergi No: {{ order.FaturaAdresi.VergiNo }}
    
                    </p>
    
                </b-card>
    
    
    
                <b-card title="Ödeme Özeti" class="flex-fill mb-0">
    
                    <div v-if="order.Odemeler[0]" class="d-flex justify-content-between font-weight-bold mb-1">
    
                        <span>Ödeme Yöntemi</span>
    
                        <span>{{ order.Odemeler[0].TaksitSayisi > 0 ? `${order.Odemeler[0].TaksitSayisi} Taksit` : "Tek Çekim" }}</span>
    
                    </div>
    
                    <hr v-if="order.Odemeler[0]" />
    
                    <div class="d-flex justify-content-between">
    
                        <span class="text-muted">Ara Tutar</span>
    
                        <span>{{ order.Tutar | formatPrice }}</span>
    
                    </div>
    
                    <div class="d-flex justify-content-between">
    
                        <span class="text-muted">KDV</span>
    
                        <span>{{ order.ToplamKdv | formatPrice }}</span>
    
                    </div>
    
                    <div v-if="order.KargoTutari > 0" class="d-flex justify-content-between">
    
                        <span class="text-muted">Kargo Tutarı</span>
    
                        <span>{{ order.KargoTutari | formatPrice }}</span>
    
                    </div>
    
                    <div v-if="order.IndirimTutari > 0" class="d-flex justify-content-between">
    
                        <span class="text-muted">İndirim Tutarı</span>
    
                        <span class="text-danger">- {{ order.IndirimTutari | formatPrice }}</span>
    
                    </div>
    
                    <hr />
    
                    <div class="d-flex justify-content-between font-weight-bold h5">
    
                        <span>TOPLAM</span>
    
                        <span>{{ order.SiparisToplamTutari | formatPrice }}</span>
    
                    </div>
    
                </b-card>
    
            </div>
    
        </div>
    
    </div>
</template>

<script>
import { BCard, BButton } from "bootstrap-vue";

export default {
    components: { BCard, BButton },
    props: {
        orderData: { type: Object, default: null },
    },
    data() {
        return {
            order: null,
        };
    },
    created() {
        if (this.orderData) {
            this.order = this.orderData;
        } else {
            this.$router.push({ name: "b2b-orders" });
        }
    },
    filters: {
        formatDate(value) {
            if (!value) return "";
            return new Date(value).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
        },
        formatPrice(value) {
            if (typeof value !== "number") return value;
            return value.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
    },
    methods: {
        getProductImage(imageUrl) {
            if (imageUrl && (imageUrl.endsWith(".jpg") || imageUrl.endsWith(".jpeg") || imageUrl.endsWith(".png") || imageUrl.endsWith(".gif"))) {
                return imageUrl;
            }
            return require("@/assets/images/icons/placeholders/no-image.png");
        },
    },
};
</script>